import React, { useEffect, useState } from 'react';
import { FaEdit, FaCheck, FaTimes } from 'react-icons/fa';
import { updateCameraName } from './cameraApi';
import Toast from './Toast';

const MotorNameEditor = ({ motor, setMotor, user }) => {
  const [newMotorName, setNewMotorName] = useState(motor.name);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setNewMotorName(motor.name);
  };

  const handleSaveClick = async () => {
    if (!newMotorName?.trim()) return;
    setSaving(true);
    try {
      await updateCameraName(motor.id, newMotorName, user.token);
      setMotor((prevMotor) => ({ ...prevMotor, name: newMotorName }));
      setIsEditing(false);
      showToast('success', 'Nom du compteur mis à jour !');
    } catch (err) {
      console.error('Erreur lors de la modification de la camera:', err);
      showToast('error', 'Échec de la modification du nom.');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    setNewMotorName(motor.name);
  }, [motor.id, motor.name]);

  return (
    <div className="text-center mb-8">
      {isEditing ? (
        <div className="flex flex-col items-center justify-center gap-4">
          <input
            type="text"
            value={newMotorName}
            onChange={(e) => setNewMotorName(e.target.value)}
            autoFocus
            className="w-full max-w-md border border-gray-300 rounded-xl px-4 py-3 text-xl sm:text-2xl font-semibold text-center shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Nom du compteur"
          />
          <div className="flex gap-3">
            <button
              onClick={handleSaveClick}
              disabled={saving}
              className="flex items-center gap-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-5 py-2.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50"
            >
              <FaCheck className="text-sm" />
              {saving ? 'Enregistrement...' : 'Valider'}
            </button>
            <button
              onClick={handleCancelClick}
              disabled={saving}
              className="flex items-center gap-2 bg-white border border-gray-300 text-gray-600 px-5 py-2.5 rounded-lg shadow-sm hover:bg-gray-50 transition-all duration-200 font-medium disabled:opacity-50"
            >
              <FaTimes className="text-sm" />
              Annuler
            </button>
          </div>
        </div>
      ) : (
        <div className="inline-flex items-center gap-3 group">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 break-words">
            {motor.name}
          </h1>
          <button
            onClick={() => setIsEditing(true)}
            className="text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-full p-2 transition-colors duration-200 shrink-0"
            aria-label="Modifier le nom"
          >
            <FaEdit className="text-lg sm:text-xl" />
          </button>
        </div>
      )}
      <Toast type={toast.type} message={toast.message} />
    </div>
  );
};

export default MotorNameEditor;